<template>
  <el-dialog title="打印" :visible.sync="dialogPrintVisible" append-to-body>
    <el-select v-model="printId" placeholder="请选择" @change="choosePrint" style="margin-bottom: 20px">
      <el-option
          v-for="item in printList"
          :key="item.id"
          :label="`${item.name} (${item.paperWidth}mm*${item.paperHeight}mm)`"
          :value="item.id">
      </el-option>
    </el-select>
    <el-button type="primary" style="margin-left: 50px" @click="printbatch" v-if="!isAll">打印</el-button>
    <el-button type="primary" style="margin-left: 50px" @click="printbatch" v-else>批量打印</el-button>
    <div id="printAll">
      <div v-for="(item,index) in printDataList" :key="index" :id="'printItem'+index"
           :style="`width: ${paperWidth}mm ;height: ${paperHeight-0.2}mm;page-break-after: always;display: flex;align-items: center;`">
        <div style="border:0.4mm black solid;" :style="`width: ${paperWidth-marginsWidth}mm ;height: ${paperHeight-marginsHeight}mm;margin:0 auto;`">
          <div style="font-weight: 600;text-align: center;justify-content: center;align-content:center" :style="{'height':(paperHeight-marginsHeight)*0.2+'mm','font-size':(paperHeight-marginsHeight)*0.2*0.4+'mm'}" >
            PLM产品生命周期管理
          </div>
          <div style="text-align: center;justify-content: center;align-content:center" :style="{'height':(paperHeight-marginsHeight)*0.6+'mm'}">
            <vue-qr
                :size="1000"
                :margin="0"
                :auto-color="true"
                :dot-scale="1"
                :text="`${codeUrl}${item.handle}`"
                class="codeImage"
                :style="`width: ${codeWidth}mm;height: ${codeWidth}mm;display: block;margin: 0 auto`"
            />
          </div>
          <div style="text-align:center;font-weight: 600;letter-spacing: 7px;justify-content: center;align-content:center" :style="{'height':(paperHeight-marginsHeight)*0.2+'mm','font-size':(paperHeight-marginsHeight)*0.2*0.4+'mm'}" v-if="userInfo.companyId==plmCompanyId">设备详情</div>
          <div style="text-align:center;font-weight: 600;justify-content: center;align-content:center" :style="{'height':(paperHeight-marginsHeight)*0.2+'mm','font-size':(paperHeight-marginsHeight)*0.2*0.4+'mm'}" v-else>
            {{ item.handle }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {selectAllPrintList} from '@/api/storeCodePrint.js'
import {
  zdyPrintAllList
} from '@/api/ryt.js'
import print from 'vue-print-nb'
import VueQr from 'vue-qr'
import {plmCompanyId,plmWZCompanyId} from "../../../../utils/constant";
export default {
  directives: {print},
  data() {
    return {
      plmCompanyId:plmCompanyId,
      plmWZCompanyId:plmWZCompanyId,
      codeUrl:"https://api.86122m.com/ryt?ryt=",
      barcode_option: {
        displayValue: false,
      },
      userInfo: '',
      companyName: '',
      codeWidth: 50,
      classHeight: 6,
      list: [],
      dialogPrintVisible: false,
      printId: '',
      printList: [],
      paperWidth: 70,
      paperHeight: 30,
      printDataList: [],
      isAll: false,
      printData: {},
      handle:'',
      marginsWidth:6,
      marginsHeight:4,
    }
  },
  components: {VueQr},
  props: {},
  created() {
    let userInfo = JSON.parse(localStorage.getItem('info'));
    this.userInfo = userInfo
    // if (this.userInfo.companyList) {
    //   this.companyName = this.userInfo.companyList[0].companyName
    // }
  },
  mounted() {
    this.getAllPrint()
  },
  methods: {
    init(batchId, handle, type) {
      this.printDataList = []
      if ('all' == type) {
        this.isAll = true
        this.getPrintData(batchId)
      } else {
        this.isAll = false
        this.printDataList.push({handle: handle})
        this.dialogPrintVisible = true
      }
    },
    initSize() {
      this.codeWidth = parseInt(this.paperWidth-this.marginsWidth)
      if (this.codeWidth > (this.paperHeight-this.marginsHeight) * 0.6) {
        this.codeWidth = parseInt((this.paperHeight-this.marginsHeight) *0.6)
      }
      this.printDataList.forEach(item => {
        var lineHeight = parseInt((this.paperHeight-this.marginsHeight) *0.6);
        if (lineHeight > 0) {
          item.classHeight = lineHeight
        }
      })
    },
    choosePrint() {
      // this.timer = new Date().getTime();
      let fe = this.printList.filter(item => {
        return item.id == this.printId
      })
      if (fe) {
        this.paperWidth = fe[0].paperWidth
        this.paperHeight = fe[0].paperHeight
      }
      this.initSize()
    },
    getAllPrint() {
      selectAllPrintList().then(res => {
        this.printList = res.data
        if (this.printList && this.printList.length > 0) {
          this.printId = this.printList[0].id
          this.choosePrint()
        }
      })
    },
    getPrintData(batchId) {
      let params = {
        batchId: batchId
      }
      zdyPrintAllList(params).then(res => {
        this.printDataList = res
        this.initSize()
        this.dialogPrintVisible = true
      })
    },
    printbatch() {
      const printStyle = `<style>@media print{body{margin: 0; padding: 0;}}</style>`;
      var newWin = window.open(""); //新打开一个空窗口
      for (var i = 0; i < this.printDataList.length; i++) {
        var imageToPrint = document.getElementById("printItem" + i); //获取需要打印的内容
        newWin.document.write(imageToPrint.outerHTML); //将需要打印的内容添加进新的窗口
      }
      newWin.document.head.innerHTML = printStyle; //给打印的内容加上样式
      newWin.document.close(); //在IE浏览器中使用必须添加这一句
      newWin.focus(); //在IE浏览器中使用必须添加这一句
      setTimeout(function () {
        newWin.print(); //打印
        newWin.close(); //关闭窗口
      }, 100);
    }
  }
}
</script>
<style scoped>
@page {
  size: auto;
  margin: 0mm;
}
</style>
